module.exports = __webpack_public_path__ + "media/images/yellow_circle_full-5f26ab9e08dff49fc6d01e94952c4c33.svg";